/*! @azure/msal-common v13.2.1 2023-08-07 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "13.2.1";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
